import React from "react";
import { OptionProps } from "react-select";
import { PresentationStyleOption, TemplateOption } from "./types";
import { colors } from "@commonsku/styles";

export const SelectOption = ({
  innerProps,
  innerRef,
  isSelected,
  isFocused,
  children
}: OptionProps<TemplateOption | PresentationStyleOption>) => {
  return (
    <div
      ref={innerRef}
      style={{
        padding: "8px 8px 8px 16px",
        cursor: "pointer",
        backgroundColor: isSelected
          ? colors.teal[60]
          : isFocused
          ? colors.primary1[20]
          : undefined,
      }}
      {...innerProps}
    >
        {children}
    </div>
  );
};
